import { render, staticRenderFns } from "./ExtraBtn.vue?vue&type=template&id=080dea50&"
import script from "./ExtraBtn.vue?vue&type=script&lang=js&"
export * from "./ExtraBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports